import {Component} from '@angular/core';
import {Router} from "@angular/router";
import { TranslocoModule } from '@jsverse/transloco';
import { PrimaryButtonComponent } from '../../shared/components/buttons/primary-button/primary-button.component';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css'],
    standalone: true,
    imports: [PrimaryButtonComponent, TranslocoModule]
})
export class NotFoundComponent {

    constructor(public router: Router) {
    }

    navigateToDashboard() {
      const ignore = this.router.navigate(['/dashboard']);
    }
}
